var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGocampaignLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 366.84 365.06",
    style: {
      enableBackground: "new 0 0 366.84 365.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#23A344;}\r\n\t.st1{fill:#1C77C7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "156.18,132.63 124.54,164.12 189.89,229.15 343.75,76.03 312.11,44.55 189.89,166.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "309.38,125.8 277.82,157.36 303.57,182.99 183.87,302.1 63.27,182.08 182.96,62.97 212.59,92.45  244.23,60.97 182.96,0 0,182.08 183.87,365.06 366.84,182.99  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGocampaignLogo01);
export default __webpack_public_path__ + "static/media/gocampaign-logo-01.f0230cf02d2ad6c814957e541f2f1f54.svg";
export { ForwardRef as ReactComponent };